import { Component, input } from '@angular/core';

@Component({
  selector: 'app-product-video-banner',
  imports: [],
  templateUrl: './product-video-banner.html',
  styleUrl: './product-video-banner.scss',
})
export class ProductVideoBanner {
  // subtitle = input<string>()
  // title = input<string>()
  // subsubtitle = input<string>()
  // videoSrc = input<string>()
  bannerVideo = input<any>()

}
